module.exports = __webpack_public_path__ + "static/32nd-1ffd9409f759a475e4317ba7cb56078c.png";